import { render, staticRenderFns } from "./LegendColor.vue?vue&type=template&id=62a1c7e7&"
import script from "./LegendColor.vue?vue&type=script&lang=js&"
export * from "./LegendColor.vue?vue&type=script&lang=js&"
import style0 from "./LegendColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports